import React from 'react'
import './ChatNotSelected.css'

function ChatNotSelected() {
  return (
    <section class="default-screen h-100">
        <div class="d-flex flex-column justify-content-between h-100">
            <div class="empty-class"></div>
            <div class="d-flex align-items-center flex-column h-100 overflow-hidden relative" style={{
              "alignItems": "center",
              "flexDirection": "column",
              "justifyContent": "center",
            }}>
                {/* <img src="img/WPFORMS.png" class="mb-3" alt="" /> */}
                <div className=''>
                  <img src="/images/Support.png" class="mb-3" alt="" />
                </div>
                <h2 class="color-white text-center mb-3">No conversations</h2>
            </div>
        </div>
    </section>
  )
}

export default ChatNotSelected


// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/ChatNotSelected/ChatNotSelected.js